import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Globals} from '../../global/globals';
import {Observable} from 'rxjs';
import {CanDoStatementCategoryCreationDto} from "../../dtos/can-do-statement/category/can-do-statement-category-creation-dto";

@Injectable({
  providedIn: 'root'
})
export class DetailedCanDoStatementCategoryService {

  private baseUri: string = this.globals.backendUri + '/cds/detailed/categories';

  constructor(private httpClient: HttpClient, private globals: Globals) {
  }

  getRootCategories(): Observable<any[]> {
    return this.httpClient.get<any[]>(this.baseUri + '/roots');
  }

  getCategoryByID(id: number): Observable<any> {
    return this.httpClient.get<any>(this.baseUri + '/' + id);
  }

  searchCategories(params: HttpParams): Observable<any> {
    return this.httpClient.get<any>(this.baseUri, {params});
  }

  createCategory(category: CanDoStatementCategoryCreationDto): Observable<any> {
    return this.httpClient.post<any>(this.baseUri, category);
  }

  updateCategory(category: CanDoStatementCategoryCreationDto): Observable<any> {
    return this.httpClient.put<any>(this.baseUri + '/' + category.id, category);
  }

  deleteCategory(id: number): Observable<void> {
    return this.httpClient.delete<void>(this.baseUri + '/' + id);
  }
}
